import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { graphRequest } from '../../msalConfig';
import { getItems, FAMILY_LISTS } from '../../api/figApi';
import MediaCover from '../components/MediaCover';

export default function Movies() {
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();

  const getToken = useCallback(async () => {
    const account = accounts[0];
    if (!account) throw new Error('Not signed in');
    const response = await instance.acquireTokenSilent({ ...graphRequest, account });
    return response.accessToken;
  }, [instance, accounts]);

  const [items, setItems] = useState(null); // null = loading
  const [error, setError] = useState(null);
  const [sortBy, setSortBy] = useState('recent');

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const token = await getToken();
        const all = await getItems(token, FAMILY_LISTS.MEDIA_ITEMS);
        if (!cancelled) {
          setItems(all.filter(item => item.MediaType === 'Movie'));
        }
      } catch (err) {
        if (!cancelled) setError(err.message);
      }
    }
    load();
    return () => { cancelled = true; };
  }, [getToken]);

  // Build display list: sort only (no filter)
  let displayed = items ?? [];
  displayed = [...displayed].sort((a, b) => {
    switch (sortBy) {
      case 'recent':
        return (b.Created ?? '').localeCompare(a.Created ?? '');
      case 'title':
        return (a.Title ?? '').toLowerCase().localeCompare((b.Title ?? '').toLowerCase());
      case 'year': {
        const ay = a.ReleaseYear ?? Number.POSITIVE_INFINITY;
        const by = b.ReleaseYear ?? Number.POSITIVE_INFINITY;
        return ay - by;
      }
      default:
        return 0;
    }
  });

  return (
    <div className="FV-shelf">
      <h1 className="FV-shelf-title">Movies</h1>

      <div className="fv-browse-toolbar">
        <select
          className="fv-browse-select"
          value={sortBy}
          onChange={e => setSortBy(e.target.value)}
          aria-label="Sort by"
        >
          <option value="recent">Recently Added</option>
          <option value="title">Title</option>
          <option value="year">Year</option>
        </select>
      </div>

      {items === null && !error && (
        <p className="FV-empty">Loading…</p>
      )}

      {error && (
        <p className="fv-browse-error">{error}</p>
      )}

      {items !== null && !error && displayed.length === 0 && (
        <p className="fv-browse-empty">No movies yet.</p>
      )}

      {displayed.length > 0 && (
        <div className="fv-browse-grid">
          {displayed.map(item => (
            <div
              key={item.id}
              className="fv-browse-card"
              onClick={() => navigate(`/movies/${item.id}`)}
            >
              <MediaCover item={item} aspectRatio="2:3" size="md" />
              <span className="fv-browse-card-title">{item.Title}</span>
              {item.ReleaseYear && (
                <span className="fv-browse-card-secondary">{item.ReleaseYear}</span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
